import React from "react";

interface ListScoreBadgeProps {
  score: number;
  label: string;
  totalVotes: number;
  className?: string;
}

const ListScoreBadge: React.FC<ListScoreBadgeProps> = ({
  score,
  label,
  totalVotes,
  className = "",
}) => {
  // Color based on score ranges and label
  const getScoreColor = (score: number, label: string) => {
    // Special handling for unrated lists
    if (label === "Unrated") {
      return "text-gray-400 border-gray-500 bg-gray-500/10";
    }

    if (score >= 85)
      return "text-yellow-400 border-yellow-400 bg-yellow-400/10";
    if (score >= 70) return "text-green-400 border-green-400 bg-green-400/10";
    if (score >= 55)
      return "text-yellow-600 border-yellow-600 bg-yellow-600/10";
    return "text-red-400 border-red-400 bg-red-400/10";
  };

  return (
    <div className={`flex flex-col items-center text-center ${className}`}>
      <div
        className={`px-3 py-1 rounded-lg border ${getScoreColor(score, label)} font-bold text-lg mb-1`}
      >
        {label === "Unrated" ? "–" : score}
      </div>
      <div className="text-sm text-gray-300 font-medium">{label}</div>
      <div className="text-xs text-gray-500">{totalVotes} votes</div>
    </div>
  );
};

export default ListScoreBadge;
